import React from "react";
import {
  ClaimsByPetitionerLawfirmInstitutionOutcomeChart,
  ClaimsByPetitionerLawfirmFWDOutcomeChart,
  ClaimsByPatentOwnerLawfirmInstitutionOutcomeChart,
  ClaimsByPatentOwnerLawfirmFWDOutcomeChart
} from "./charts";
import { Divider } from "antd";
import UserAccess from "@/components/common/user-access";

const ClaimTabCounsel = props => {
  const q = props.query;
  return (
    <UserAccess isPublicSignupAllowed={true} showHelp={true}>
      <ClaimsByPetitionerLawfirmInstitutionOutcomeChart query={q} />
      <Divider />
      <ClaimsByPetitionerLawfirmFWDOutcomeChart query={q} />
      <Divider />
      <ClaimsByPatentOwnerLawfirmInstitutionOutcomeChart query={q} />
      <Divider />
      <ClaimsByPatentOwnerLawfirmFWDOutcomeChart query={q} />
    </UserAccess>
  );
};

export default ClaimTabCounsel;
